import styled from 'styled-components';

import colors from '../../../../../styles/colors';

const CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${colors.shades.secondary10};
  padding: 0 0 35px 50px;
  gap: 30px;
`;

export {
  CardsContainer,
};
